import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-completemultipart',
  templateUrl: './completemultipart.component.html',
  styleUrls: ['./completemultipart.component.css']
})
export class CompletemultipartComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }



  requestData = `
  curl -v 'https://api.optimusdrive.ai/vod/v1/customer/multipart/complete' \
  -H 'authorization: XXX' \
  --data-raw '{"key_path":"vod/input/bc96e670-4450-42c1-a53c-5175182040e2/ab7b5129-09c0-496f-891b-be082efee32e/6min_1080pVideo.MOV","parts":[{"etag":"40705bec33b8544f57d61ede8b9c4ee9","part_number":1},{"etag":"0f050df370da9dc2721917d4c4e22a5b","part_number":2},{"etag":"329f98d34f6d22d9a4a3f3021ec38f66","part_number":3},{"etag":"8a44e627bc86ce5f355e926a510efd6b","part_number":4}],"upload_id":"JveSaMcKZ5wNRWOwy20zgpHE8xoVNMj2Z.b3YQJlbigKDYpKhx8fg1gjEIfvyIos1KfnmD.NTo.w7g2lwaKb_FF.gE9Zm5f807sxIY.RmG2GdIKeiUc2h6n_PZfeQlw5Tr.dDpMAfg0hZmv7DFPfwY537FcYv.gp1mxgW7UJLB3roK7U0Mo7wQwXLRi"}' 

  `

  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
       this.copyButton = false;
       this.copiedButton = true;
  // After a few seconds, reset the button states
      setTimeout(() => {
        this.copyButton = true;
        this.copiedButton = false;
      }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }





  sucessData = `
{
    "data": {
        "Bucket": "cmw-optimus-media",
        "BucketKeyEnabled": null,
        "ChecksumCRC32": null,
        "ChecksumCRC32C": null,
        "ChecksumSHA1": null,
        "ChecksumSHA256": null,
        "ETag": "\"f79f9046aff21671e422fd3a13dd0c66-14\"",
        "Expiration": null,
        "Key": "vod/input/bc96e670-4450-42c1-a53c-5175182040e2/ab7b5129-09c0-496f-891b-be082efee32e/6min_1080pVideo.MOV",
        "Location": "https://cmw-optimus-media.s3.amazonaws.com/vod%2Finput%2Fbc96e670-4450-42c1-a53c-5175182040e2%2Fab7b5129-09c0-496f-891b-be082efee32e%2F6min_1080pVideo.MOV",
        "RequestCharged": null,
        "SSEKMSKeyId": null,
        "ServerSideEncryption": "AES256",
        "VersionId": null
    },
    "message": "Upload completed successfully"
}
  
`

  Error5x = `
  {
    "error": {},
    "message": "string"
  }
  `


  Error4x =`
  {
    "error": "InvalidParameter: 1 validation error(s) found.\n- minimum field size of 1, CompleteMultipartUploadInput.Key.\n",
    "message": "Error completing upload."
  }`

  Error42x =`
  {
    "error": "MalformedXML: The XML you provided was not well-formed or did not validate against our published schema\n\tstatus code: 400, request id: FCR56718VVW4TQE7, host id: DN4p2ZZqiDigW4XIPLtppCxF4lER4OuuDpuOTnw7b2hNJKBTozxaU78keQ0appjHMRtLnrQCMAY=",
    "message": "Error completing upload."
  }
  
  `

  Error43x =`
  {
    "error": "NoSuchUpload: The specified upload does not exist. The upload ID may be invalid, or the upload may have been aborted or completed.\n\tstatus code: 404, request id: KVCYR4CCPQMMAM0P, host id: gf0DClLu6pKihnoxJZcmv1TeV+LR4yagux40h7jxkAO5x06dBzq+6Np0c7JqPFTuAVzUE9Kw6gzj+rPzx4o6isZ2/BxJBhQtwmw+eoDcv5E=",
    "message": "Error completing upload."
  }
  
  `



  Error401x=`
  {
    "error": {},
    "message": "Unauthorized"
  }
  `



}
